<div>
  <app-product-add-navbar
    [currentStep]="currentStep"
    [productSteps]="productSections"
    [lastVisitedStep]="lastVisitedStep"
    [editing]="editing"
    (navigateToStep)="updateStep($event)"
  ></app-product-add-navbar>
  <div class="form-container">
    <div class="user-note">
      <small>{{ translationService.getFieldRequiredIndicatorText() }}</small>
    </div>
    <app-product-overview-form
      (formChanged)="saveProductFormData($event)"
      [ngClass]="currentStep !== 0 ? 'inactive-step' : 'active-step'"
      [clonedData]="$safeNavigationMigration(clonedProductData?.overviewForm)"
      [editing]="editing"
    ></app-product-overview-form>
    <app-product-recyclability-form
      (formChanged)="saveRecyclabilityFormData($event)"
      (backPressed)="goToPrevStep()"
      (isPlasticPackaging)="onIsPlasticPackaging($event)"
      [ngClass]="currentStep !== 1 ? 'inactive-step' : 'active-step'"
      [clonedData]="
        $safeNavigationMigration(clonedProductData?.recyclabilityForm)
      "
    ></app-product-recyclability-form>
    <app-product-ghs-form
      [ngClass]="currentStep !== 2 ? 'inactive-step' : 'active-step'"
      (backPressed)="goToPrevStep()"
      (formChanged)="saveGhsClassicationFormData($event)"
      [clonedData]="
        $safeNavigationMigration(clonedProductData?.ghsClassificationForm)
      "
    ></app-product-ghs-form>
    <app-product-ingredients-form
      (formChanged)="saveIngredientFormData($event)"
      (backPressed)="goToPrevStep()"
      [ngClass]="currentStep !== 3 ? 'inactive-step' : 'active-step'"
      [clonedData]="$safeNavigationMigration(clonedProductData?.ingredientForm)"
    ></app-product-ingredients-form>
    <app-product-components-form
      (formChanged)="saveComponentFormData($event)"
      (backPressed)="goToPrevStep()"
      [clonedData]="$safeNavigationMigration(clonedProductData?.componentForm)"
      [ngClass]="currentStep !== 4 ? 'inactive-step' : 'active-step'"
    ></app-product-components-form>
    <app-product-plastics-declaration-form
      (formChanged)="savePlasticsDeclarationFormData($event)"
      (backPressed)="goToPrevStep()"
      [isPlasticPackaging]="isPlasticPackaging"
      [clonedData]="
        $safeNavigationMigration(clonedProductData?.plasticsDeclarationForm)
      "
      [components]="componentForm?.components || []"
      [componentGroups]="componentForm?.componentGroups || []"
      [ngClass]="currentStep !== 5 ? 'inactive-step' : 'active-step'"
    ></app-product-plastics-declaration-form>
  </div>
</div>
